import { Icon } from '@iconify/react';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { createPatientBooking } from '../../service/api';
import Toast from '../Toast';
import dayjs from 'dayjs';

export default function AppointmentForm() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ message: '', type: 'success' });

  const showToast = (msg, type = 'success') => {
    setToast({ message: msg, type });
    setTimeout(() => setToast({ message: '', type }), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) {
      showToast(
        'Vui lòng nhập đầy đủ Họ tên, Số điện thoại và Ngày khám!',
        'error'
      );
      return;
    }
    setLoading(true);
    try {
      await createPatientBooking({
        clinicId: '123123',
        name,
        phone,
        note,
        date: selectedDate ? dayjs(selectedDate).format('YYYY-MM-DD') : '',
      });
      showToast('Thành công!', 'success');
      setName('');
      setPhone('');
      setNote('');
      setSelectedDate(null);
    } catch (error) {
      showToast('Đặt lịch thất bại!', 'error');
    }
    setLoading(false);
  };

  const isFormValid = name.trim() && phone.trim() && selectedDate;

  return (
    <>
      <Toast
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: '', type: 'success' })}
      />
      <form className='row' onSubmit={handleSubmit}>
        <div className='col-lg-6'>
          <label className='cs_input_label cs_heading_color'>Họ và tên</label>
          <input
            type='text'
            className='cs_form_field'
            placeholder='Họ và tên'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className='cs_height_42 cs_height_xl_25' />
        </div>
        <div className='col-lg-6'>
          <label className='cs_input_label cs_heading_color'>
            Số điện thoại
          </label>
          <input
            type='text'
            className='cs_form_field'
            placeholder='Số điện thoại'
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <div className='cs_height_42 cs_height_xl_25' />
        </div>

        <div className='col-lg-12'>
          <label className='cs_input_label cs_heading_color'>Ngày khám</label>

          <div className='cs_with_icon_input'>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat='dd/MM/yyyy'
              minDate={new Date()}
              isClearable
              placeholderText='dd/mm/yyyy'
            />
            <i>
              <Icon icon='fa6-solid:calendar-days' />
            </i>
          </div>
          <div className='cs_height_42 cs_height_xl_25' />
        </div>
        <div className='col-lg-12'>
          <label className='cs_input_label cs_heading_color'>
            Nội dung khám
          </label>
          <textarea
            className='cs_form_field'
            placeholder='Nội dung khám'
            rows={4}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <div className='cs_height_42 cs_height_xl_25' />
        </div>

        <div className='col-lg-12'>
          <button
            className='cs_btn cs_style_1'
            type='submit'
            disabled={loading}
          >
            <span>{loading ? 'Đang gửi...' : 'Đặt lịch'}</span>
            <i>
              <img src='/images/icons/arrow_white.svg' alt='Icon' />
              <img src='/images/icons/arrow_white.svg' alt='Icon' />
            </i>
          </button>
        </div>
      </form>
    </>
  );
}
